import React, {Component} from 'react';
import T from 'i18n-react';
import Divider from 'material-ui/Divider';
import './EditMyPassword.css'
// WebServices
import UserService from '../../services/UserService';
// Composants
import RaisedButton from 'material-ui/RaisedButton';
import MaterialFormInput from '../../components/materialFormInput/MaterialFormInput';
// Enum
import COLORS from '../../enums/ColorEnum';
// Utils
import { makeCancelable } from '../../utils/PromiseUtils';
// User form utils
import { red400 } from 'material-ui/styles/colors';

import NotificationSystem from 'react-notification-system';
import { notificationStyle } from '../../utils/NotificationUtils';

const inputConfigs = {
    fullWidth: true,
    inputStyle: {
        color: COLORS.BLACK
    },
    floatingLabelStyle: {
        color: COLORS.BLACK
    },
    floatingLabelFocusStyle: {
        color: COLORS.GREY,
    }
};

const buttonConfigs = {
    backgroundColor: COLORS.GREEN,
    labelColor: COLORS.WHITE,
    fullWidth: true,
    style: {
        marginTop: '20px'
    }
};

const MATCHING_NUMERIC = '[0-9]';
const MATCHING_CHAR = '[a-zA-Z]';

class EditMyPassword extends Component {

    /*************************************************
     * **************** LifeCycle ********************
     *************************************************/

    constructor(props) {
        super(props);
        this.state = {
            fields: {
                oldPassword: '',
                newPassword: '',
                confirmPassword: ''
            },
            isValid: false,
        };
    }

    /**
     * Annulation de toutes les promesses encore en cours lorsque
     * l'on quitte le composant
     */
    componentWillUnmount() {
        this._promises.forEach(promise => promise.cancel());
    }

    /**
     * On set le system de notification après que la page soit chargé
     */
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
    }

    render() {
        return (
            <div className="editUserPage">
                <div className="headerEditUserPage">
                    <span className="headerTitleEditUser">{T.translate('menuTop.editMyPassword')}</span>
                </div>
                <Divider/>
                <form className='editMyPasswordForm' onSubmit={this.onSubmit}>
                    <h1 className="userFormMessage">{T.translate('userForm.editPasswordLabel')} </h1>

                    { this.state.error ?
                        <div style={{color:red400}}> {T.translate(this.state.error)}</div> : null
                    }
                    <MaterialFormInput id="oldPassword"
                                       name="oldPassword"
                                       className="input"
                                       floatingLabelText={T.translate('userForm.fields.oldPassword')}
                                       value={this.state.fields.oldPassword}
                                       onChange={this.handleInputChange}
                                       type='password'
                                       configs={inputConfigs}
                    />


                    <MaterialFormInput id="newPassword"
                                       name="newPassword"
                                       className="input"
                                       floatingLabelText={T.translate('userForm.fields.newPassword')}
                                       value={this.state.fields.newPassword}
                                       onChange={this.handleInputChange}
                                       type='password'
                                       configs={inputConfigs}
                    />

                    <MaterialFormInput id="confirmPassword"
                                       name="confirmPassword"
                                       className="input"
                                       floatingLabelText={T.translate('userForm.fields.confirmPassword')}
                                       value={this.state.fields.confirmPassword}
                                       onChange={this.handleInputChange}
                                       type='password'
                                       configs={inputConfigs}/>

                    <RaisedButton label={T.translate('userForm.submit')}
                                  className="userFormSubmitButton"
                                  type="submit"
                                  style={{marginTop: 0}}
                                  disabled={!this.state.isValid}
                                  {...buttonConfigs}/>
                </form>
                <NotificationSystem ref="notificationSystem" style={notificationStyle}/>
            </div>
        );
    }

    /*************************************************
     ******************* Actions *******************
     *************************************************/

    /**
     * Action déclanché lors du submit du formulaire
     * @param e
     */
    onSubmit = (e) => {
        e.preventDefault();
        const editPasswordPromise = UserService.editPassword(this.state.fields.oldPassword, this.state.fields.newPassword);
        const cancelablePromise = makeCancelable(editPasswordPromise);
        this._promises.push(cancelablePromise);

        cancelablePromise
            .promise
            .then(() => {
                this._addNotification(T.translate('userForm.userSuccessfullyChangePassword'), 'success');
                this.clearAction()
            })
            .catch((error) => {
                if (!error.isCanceled) {
                    this._addNotification(T.translate('common.errorOccurred'), 'error');
                }
            })
            .then(() => this.promiseFulfilled(cancelablePromise));
        // TODO : appel au WS update password
        // const formData = this.getFormDataPreparedForRequest();
        // this.props.onSubmit(formData);
    };

    /**
     * Séléctionne une champ (de type TextInput) puis
     * valide le formulaire
     * @param event
     */
    handleInputChange = (event) => {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        this.setState({
            fields: {
                ...this.state.fields,
                [name]: value
            }
        }, this.validateForm);
    };

    validateForm() {
        if(!this.state.fields.oldPassword || !this.state.fields.newPassword || !this.state.fields.confirmPassword) {
            this.setState({'isValid': false, 'error': ''})
        } else if(this.state.fields.newPassword.length < 8 || this.state.fields.newPassword.length > 255) {
            this.setState({'isValid': false, 'error': 'login.firstConnexion.password'})
        } else if(!this.state.fields.newPassword.match(MATCHING_CHAR) || !this.state.fields.newPassword.match(MATCHING_NUMERIC)) {
            this.setState({'isValid': false, 'error': 'login.firstConnexion.password'})
        } else if(this.state.fields.newPassword !== this.state.fields.confirmPassword) {
            this.setState({'isValid': false, 'error': 'login.firstConnexion.missMatchPassword'})
        } else {
            this.setState({'isValid' : true, 'error': ''})
        }
    }

    clearAction() {
        this.setState({isValid: true, fields: {
            oldPassword: '',
            newPassword: '',
            confirmPassword: ''
        }})
    }

    /**********************************************************
     * ************** Gestion des promises ******************
     **********************************************************/

    _promises = [];

    /**
     * On retire la promise de la liste des promises en cours
     * Cette fonction doit etre appelé après que la promise est rempli
     * @param promise
     */
    promiseFulfilled = (promise) => {
        const index = this._promises.indexOf(promise);

        if (index !== -1) {
            this._promises.splice(index, 1);
        }
    };

    /*************************************************
     ****************Notifications ******************
     *************************************************/

    _notificationSystem = null;

    _addNotification = (message, level) => {
        this._notificationSystem.addNotification({
            message,
            autoDismiss: 5,
            level,
            position: 'tr'
        });
    }

}

export default EditMyPassword;



// WEBPACK FOOTER //
// ./src/ui/editMyPassword/EditMyPassword.js